import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { AbstractHttpService } from 'src/app/commons/abstract-http.service';
import { TrocarSenhaDialogComponent } from 'src/app/components/trocar-senha-dialog/trocar-senha-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class TrocarSenhaService extends AbstractHttpService {


  private modalOpened = false;
  private dialogRef: MatDialogRef<TrocarSenhaDialogComponent>;

  constructor(http: HttpClient, private dialog: MatDialog) {
    super(http);
  }

  abrirModalTrocaDeSenha() {
    if (!this.modalOpened) {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(TrocarSenhaDialogComponent, { width: '400px', disableClose: true });
        this.dialogRef.afterClosed().subscribe(() => {
          this.modalOpened = false;
        });
      });
    }

    this.modalOpened = true;
  }

  fecharModal() {
    if (!this.dialogRef) return;
    this.dialogRef.close();
  }

}
